import { render } from "./Udvalg.vue?vue&type=template&id=60a1e816&ts=true"
import script from "./Udvalg.vue?vue&type=script&lang=ts"
export * from "./Udvalg.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__